import React, { lazy, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  MainContainer,
  RecogntionTopCard,
  // FeaturedCard
} from "../Recognition/CompanyAnalytics/styles";
import { ImageUrl } from "../../utils/constants";
import { commaSeperator } from "../../utils/methods";
import {TopChallengesWrapper} from "../CompanyEvents/styles";
const TopDataGraph = lazy(() => import('../common/Analytics/TopThreeDataGraph'));
import { Table } from '../common/commonStyles';
import {Heading, ScrollableContainer, /*ShowMore*/ } from '../RecogntionAdmin/styles'
import MonthlyBarChart from "../common/Manager/MonthlyChart/MonthlyBarChart";
import {NoInitiativeCard, CommonButton, HoverBackground, /*HdmTopCard,*/ NewScheduledCard, /*HealthMetricCardsWrapper, HealthMetricCard*/} from './styles'
import {/*LaunchInitiatives, WellnessInitiatives,*/ RecognitionEyeIcon, /*UpcomingInitiatives, DownArrow, DeleteIconBranding, InfoIcon,*/ HealthDataIconNew ,CircularTickIconNew, WarningIconV1, StarIcon} from '../../utils/icons'
// import HalfCircularProgressBar from '../common/HalfCircularProgressBar/HalfCircularProgressBar'
import SkeletonLoder from "../common/skeletonLoder";
import { NameInitials } from "../Manager/styles";
import { getInitials, fetchApi } from "../../utils/methods";
import DetailPopup from './initiativesInfo';
import DeletePopup from '../DeletePostPopup/deletePopupBranding'
import { DeleteCompanyInitiative, GetActiveUpcomingInitiativesV2, GetTopWellnessInitiativesV2, GetHealthDataSnapshotV2, GetBestHealthPerformersV2, GetTopHealthDepartmentAndLocationsV2,GetActiveRecurringInitiatives, ArchiveCompanyInitiative } from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import ActiveInitiativeCard from './ActiveInitiativeCard';
import CustomNotification from '../ChallengeDetailsV2/customNotification';
import InitiativeSlider from "./InitiativeSlider";
import WellnessPrioritiesPopup from "./WellnessPrioritiesPopup";
import {  NewVideoPlayer , EventCard, NewContentV2, CircleContainerV2} from "../MainEvents/RecommendEventVideos/styles";
import Thumbnail from "../Thumbnail";
import { TextContainer } from "../ChallengeDetailsV2/WellnessChallenge/styles";
import moment from "moment";
import Waiting from "../Waiting";
import CommonModalNew from "../common/CommonModal/CommonModalNew";

const CompanyAnalytics = ({history, /*manageHealthTabs,*/ companyId, /*showHideCustomize, getFeatured,*/ /*getActive, getUpcoming, selectedYear,*/ fetchUpcomingInitiatives, selectedRewardPeriod}) => {
  const [showEmployeeQuarter, setShowEmployeeQuarter] = useState(false);
  const [showEmployeeMonth, setShowEmployeeMonth] = useState(false);
  const [onHover, setHover] = useState(null);
  const [showDetailPopup, setShowDetailPopup] = useState(false);
  const [detailInitiative, setDetailInitiative] = useState({});
  // const [showAllActive, setShowAllActive] = useState(false);
  // const [showAllUpcoming, setShowAllUpcoming] = useState(false);
  const [deleteInitiative, setDeleteInitiative] = useState(false);
  const [deleteInitiativeData, setDeleteInitiativeData] = useState({});
  const [activeInitiativesNew, setActiveInitiativesNew] = useState([]);
  const [upcomingInitiativesNew, setUpcomingInitiativesNew] = useState([]);
  const [wellnessPriorityInitiatives, setWellnessPriorityInitiatives] = useState([]);
  const [notificationInitiative, setNotificationInitiative] = useState(null);
  const [healthSnapshot, setHealthSnapshot] = useState(null);
  const [monthlyPerformers, setMonthlyPerformers] = useState([]);
  const [monthlyMeta, setMonthlyMeta] = useState({ total: 0, month_name: '' });
  const [monthlyPage, setMonthlyPage] = useState(1);
  const [quarterlyPerformers, setQuarterlyPerformers] = useState([]);
  const [quarterlyMeta, setQuarterlyMeta] = useState({ total: 0, quarter_name: '' });
  const [quarterlyPage, setQuarterlyPage] = useState(1);
  const [deptAndLocData, setDeptAndLocData] = useState({});
  const [recurringInititives, setRecurringInitiatives] = useState([])
  const [recurringLoading, setRecurringLoading] = useState(false)
  const [wellnessPriorityPopup, setWellnessPriorityPopup] = useState(false)
  const [scheduleHover, setScheduleHover] = useState(false)
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [initiativeToArchive, setInitiativeToArchive] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);

  React.useEffect(() => {
    if (!companyId || !selectedRewardPeriod?.reward_period_id) return;
    const loadAll = async () => {
      setPageLoading(true);
      try {
        await fetchActiveInitiativesNew();
        await fetchWellnessPriorityInitiatives();
        await fetchHealthSnapshot();
        fetchMonthlyPerformers(1);
        fetchQuarterlyPerformers(1);
        fetchDeptAndLocData();
        FetchActiveRecurringInitiatives();
      } finally {
        setPageLoading(false);
      }
    };
    loadAll();
  }, [companyId, selectedRewardPeriod]);

  const FetchActiveRecurringInitiatives = async()=>{
    setRecurringLoading(true); 
    try {
      // const apiUrl = `${GetActiveRecurringInitiatives}?company_id=${companyId}&reward_period_id=${rewardPeriodId}`;
      const apiUrl = `${GetActiveRecurringInitiatives}?company_id=${companyId}&reward_period_id=${selectedRewardPeriod.reward_period_id}`;
      const res = await fetchApi(apiUrl, "GET");
      if(res.status === 'success'){
        setRecurringInitiatives(res.data)
        setRecurringLoading(false); 
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
    finally {
      setRecurringLoading(false);   // 👈 stop loading always
    }
  }

  window.console.log("notificationInitiative",notificationInitiative)

  const fetchDeptAndLocData = async () => {
    try {
      const res = await fetchApi(
        `${GetTopHealthDepartmentAndLocationsV2}?company_id=${companyId}&reward_period_id=${selectedRewardPeriod.reward_period_id}&type=year`,
        'GET'
      );
      if (res.status === 'success') {
        setDeptAndLocData(res.data || {});
      }
    } catch { /* silent */ }
  };

  const fetchActiveInitiativesNew = async () => {
    try {
      const res = await fetchApi(
        `${GetActiveUpcomingInitiativesV2}?company_id=${companyId}&reward_period_id=${selectedRewardPeriod.reward_period_id}&type=year`,
        'GET'
      );
      if (res.status === 'success') {
        setActiveInitiativesNew(res?.data?.active_initiatives || []);
        setUpcomingInitiativesNew(res?.data?.upcoming_initiatives || []);
      } else {
        toast.error(res.message || 'Failed to fetch active initiatives');
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const fetchWellnessPriorityInitiatives = async () => {
    try {
      const res = await fetchApi(
        `${GetTopWellnessInitiativesV2}?company_id=${companyId}&reward_period_id=${selectedRewardPeriod.reward_period_id}`,
        'GET'
      );
      if (res.status === 'success') {
        setWellnessPriorityInitiatives(res?.data?.initiatives || res?.data || []);
      } else {
        toast.error(res.message || 'Failed to fetch wellness priorities');
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const fetchHealthSnapshot = async () => {
    try {
      const res = await fetchApi(
        `${GetHealthDataSnapshotV2}?company_id=${companyId}&reward_period_id=${selectedRewardPeriod.reward_period_id}&type=year`,
        'GET'
      );
      if (res.status === 'success') {
        setHealthSnapshot(res.data || {});
      }
    } catch { /* silent */ }
  };

  const fetchMonthlyPerformers = async (page) => {
    try {
      const res = await fetchApi(
        `${GetBestHealthPerformersV2}?company_id=${companyId}&reward_period_id=${selectedRewardPeriod.reward_period_id}&type=month&page=${page}&limit=7`,
        'GET'
      );
      if (res.status === 'success') {
        const users = res.data?.current_month?.data || res.data?.users || res.data || [];
        const total = res.data?.current_month?.total ?? res.total ?? 0;
        const month_name = res.data?.current_month?.month_name || '';
        setMonthlyPerformers((prev) => page === 1 ? users : [...prev, ...users]);
        setMonthlyMeta({ total, month_name });
        setMonthlyPage(page);
      }
    } catch { /* silent */ }
  };



  const handleArchive = async () => {
    try {
      const res = await fetchApi(ArchiveCompanyInitiative, 'DELETE', {
        company_initiative_id: initiativeToArchive,
      });
      if (res.status === 'success') {
        toast.success('Initiative archived successfully');
        // history.goBack();
        fetchActiveInitiativesNew();
      } else {
        toast.error(res.message || 'Failed to archive initiative');
      }
    } catch (err) {
      toast.error(err.message);
    }
    setShowArchiveModal(false);
  };

  // const METRIC_CARDS = [
  //   { title: 'Velocity Score', key: 'user_initiatives_launched_percentage', color: '#75B084' },
  //   { title: 'Workplace Well-being', key: 'user_WBA_taken_percentage', color: '#75B084' },
  //   { title: 'Employee Wellness', key: 'user_initiative_taken_percentage', color: '#75B084' },
  //   { title: 'Biometric 3 Year Cost', key: 'biometric_cost', isCost: true, color: '#75B084' },
  // ];

  // const renderHealthMetricCards = () => (
  //   <HealthMetricCardsWrapper>
  //     {METRIC_CARDS.map(({ title, key, color, isCost }) => {
  //       const value = healthSnapshot?.top_4_cards?.[key] ?? 0;
  //       return (
  //         <HealthMetricCard key={key}>
  //           <div className="card-title-row">
  //             <span className="card-title">{title}</span>
  //             <span className="info-icon">{InfoIcon('#649BB3')}</span>
  //           </div>
  //           {isCost ? (
  //             <div className="amount-area">
  //               <div>
  //                 <div className="amount-value">${commaSeperator(value)}</div>
  //                 {/* <div className="amount-label">3 Year Projection</div> */}
  //               </div>
  //             </div>
  //           ) : (
  //             <div className="chart-area">
  //               <HalfCircularProgressBar
  //                 percentage={Number(value) || 0}
  //                 color={color}
  //                 size={180}
  //                 strokeWidth={14}
  //               />
  //             </div>
  //           )}
  //         </HealthMetricCard>
  //       );
  //     })}
  //   </HealthMetricCardsWrapper>
  // );

  const hideDeleteInitiative = () => {
    setDeleteInitiative(false);
  }

  // const showDeleteInitiativePopup = (data) =>{
  //   setDeleteInitiative(true)
  //   setDeleteInitiativeData(data)
  // }

  const deleteInitiativeApiCall = async () => {
    try {
      const startDate = deleteInitiativeData?.start_date;
      const endDate = deleteInitiativeData?.end_date;
      const postData = {
        company_id: companyId,
        initiative_id: deleteInitiativeData.id,
        start_date: startDate,
        end_date: endDate,
      }; 
      const res = await fetchApi(
        DeleteCompanyInitiative+"/"+companyId,
        "POST",
        postData,
        {},
      );
      if (res.message) {
        toast.error(res.message);
      }
      fetchUpcomingInitiatives()
      setDeleteInitiative(false)
      setDeleteInitiativeData()
      toast.success("Initiative deleted successfully");
    } catch (error) {
      toast.error(error.message);
    }
  };

  // const currentYear = new Date().getFullYear();
  // const hideCardsForPreviousYear= selectedYear==currentYear

  const showInitiativeInfo = (value) => {
    setShowDetailPopup(true)
    setDetailInitiative(value)
  }

  const hideInitiativeInfo = () => {
    setShowDetailPopup(false)
  }

  const topDepartment = () => {
    const department=deptAndLocData?.top_three_departments
    const dataArray = [
      { name: department[0]?.name, color: '#FFF', value: department[0]?.total_participation, width: 204, background: '#BE7D9C' },
      { name: department[1]?.name, color: '#FFF', value: department[1]?.total_participation, width: 160, background: '#92A4DA' },
      { name: department[2]?.name, color: '#FFF', value: department[2]?.total_participation, width: 96, background: '#75B084' },
    ];
    return (
      deptAndLocData?.top_three_departments?.length>0&&<TopDataGraph data={dataArray} heading={'Top Performing Departments'} total={deptAndLocData?.total_top_departments} totalSubText='Total Initiatives' />
    );
  };

  const topLocation = () => {
    const location=deptAndLocData?.top_three_locations
    const dataArray = [
      { name: location[0]?.name, color: '#FFF', value: location[0]?.total_participation, width: 204, background: '#B1AA56' },
      { name: location[1]?.name, color: '#FFF', value: location[1]?.total_participation, width: 160, background: '#DA92C8' },
      { name: location[2]?.name, color: '#FFF', value: location[2]?.total_participation, width: 96, background: '#DA6C74' },
    ];
    return (
      deptAndLocData?.top_three_locations?.length>0&&<TopDataGraph data={dataArray} heading={'Top Performing Locations'} total={deptAndLocData?.total_top_locations} totalSubText='Total Initiatives' />
    );
  };

  const redirectToCompanyInitiative = (obj) => {
    history.push({pathname: "/company/company-initiative", state: {id: obj?.id, initiative_name: obj?.initiative_name,initiativeDetails:obj}});
  };

  const showRecognitionDetails = () => {
    const EngagementEmployeeData = [
      {
        title: "Total Initiatives Launched",
        value: "1",
        img: "images/AdminReports/total.svg",
        text: "posted",
        color: "rgba(133, 192, 234, 1)",
        total: (healthSnapshot?.top_4_cards?.total_initiatives_launched),
        imageBackground: "#FCF2F3",
        info: "",
        // average:`Avg ${healthSnapshot?.top_4_cards?.user_initiatives_launched_percentage} initiative launched per users`,
        average:`Avg ${healthSnapshot?.top_4_cards?.avg_initiatives_launched} initiative launched per users`,
        is_launch:1,
        showHover: false,
        icon:HealthDataIconNew(),
        id:4
      },
      {
        title: "Completed Initiatives",
        titleNew: "",
        value: "2",
        img: "images/AdminReports/completed.svg",
        text: "received recognition",
        color: "rgba(220, 148, 181, 1)",
        total: (healthSnapshot?.top_4_cards?.completed_initiatives),
        average: healthSnapshot?.top_4_cards?.user_initiative_taken_percentage+ "% users taken initiative",
        imageBackground: "#FCF2F3",
        info: "",
        is_launch:1,
        id:3,
        showHover: false,
        icon:CircularTickIconNew(),
      },
      {
        title: "WBA Participation",
        value: "3",
        img: healthSnapshot?.default_initiative_details&& healthSnapshot?.default_initiative_details[0]?.initiative_white_icon,
        text: "gave recognition",
        color: "rgba(118, 171, 120, 1)",
        total: (healthSnapshot?.top_4_cards?.total_wba_participation),
        average:`${healthSnapshot?.top_4_cards?.user_WBA_taken_percentage}% of users participated`,
        imageBackground: '#FCF2F3',
        info: "",
        is_launch:healthSnapshot?.top_4_cards?.WBA_status,
        id: 1,
        showHover: false,
        isLaunch:healthSnapshot?.top_4_cards?.WBA_status
      },
      {
        title: "Biometrics Participation",
        titleNew: "Value",
        value: "4",
        img: healthSnapshot?.default_initiative_details && healthSnapshot?.default_initiative_details[1]?.initiative_white_icon,
        text: "received value",
        color: "rgba(175, 135, 193, 1)",
        total: (healthSnapshot?.top_4_cards?.total_biometrics_participation),
        average:`${healthSnapshot?.top_4_cards?.user_biometrics_taken_percentage}% of users participated`,
        imageBackground: '#FCF2F3',
        info: "",
        is_launch:healthSnapshot?.top_4_cards?.biometrics_status,
        id:2,
        showHover: false,
        isLaunch:healthSnapshot?.top_4_cards?.biometrics_status
      },
    ];
    return (
      EngagementEmployeeData?.map((details, index) => (
        healthSnapshot?.top_4_cards?
          <RecogntionTopCard padding={onHover===details?.id&&details?.showHover&&details?.isLaunch?"0px":"12px"} display key={index} background={details.imageBackground} onMouseEnter={details?.isLaunch?() => setHover(details?.id):null} onMouseLeave={() => setHover(-1)}>
            <div className="image" style={{border:'0.75px solid #E4888C'}}>
              {details.id === 4 || details.id === 3 ? details.icon : <img src={ImageUrl +'/'+ details.img} />}
            </div>
            <div className="title">{details.title}</div>
            {details?.is_launch?<>
              <div className="value">{commaSeperator(details?.total)}</div>
              <div className="percent-user">{details.average}</div>
            </>:
              <div className="button-launch">
                <CommonButton width="200px !important" backgroundColor={'#DA6C74'} style={{height:"40px"}} onClick={index===2?()=>redirectToCompanyInitiative(healthSnapshot?.default_initiative_details[0]): ()=>redirectToCompanyInitiative(healthSnapshot?.default_initiative_details[1])}>{index===2?"Launch WBA":"Launch Biometric"}</CommonButton>
              </div>}
            {onHover===details?.id&&details?.showHover&&<HoverBackground >
              <div className='view-button'
                // onClick={() => showInitiativeInfo(details)}
                onClick={index===2?()=>showInitiativeInfo(healthSnapshot?.default_initiative_details[0]): ()=>showInitiativeInfo(healthSnapshot?.default_initiative_details[1])}
                onMouseEnter={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}
                onMouseLeave={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}>
                <div style={{ marginRight: '10px' }}>{RecognitionEyeIcon('#FEFEFE')}</div>{("View")}
              </div>
            </HoverBackground>}
          </RecogntionTopCard>:<SkeletonLoder width="290px" height="200px" key={index}/>
      )));
  };

  // const featuerdInitiatives = () => {
  //   const featureCards =getFeatured;
  //   return featureCards?.map((details, index) => (
  //     <FeaturedCard display key={index} width background={details.color} onMouseEnter={details?.is_launch? () => setHover(details?.id):null} onMouseLeave={() => setHover(-1)}>
  //       <div className="wrapFeaturted">
  //         <div className="image">
  //           <img src={ImageUrl +"/"+ details?.initiative_white_icon} />
  //         </div>
  //         <div className="title">{details.initiative_name}</div>
  //         {details?.is_launch?<>
  //           <div className="value">{commaSeperator(details?.total_participation)}</div>
  //           <div className="percent-user">{details?.user_initiative_taken_percentage}% of users have completed the initiative</div>
  //         </>:
  //           hideCardsForPreviousYear&&<div className="button-launch" >
  //             <CommonButton width="200px" onClick={()=>redirectToCompanyInitiative(details)}><div className="icon"><LaunchInitiatives/></div>Launch Initiative</CommonButton>
  //           </div>}
  //       </div>
  //       {onHover===details?.id&&<HoverBackground width>
  //         <div className='view-button'
  //           onClick={() => showInitiativeInfo(details)}
  //           onMouseEnter={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}
  //           onMouseLeave={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}>
  //           <div style={{ marginRight: '10px' }}>{RecognitionEyeIcon('#FEFEFE')}</div>{("View")}
  //         </div>
  //       </HoverBackground>}  
  //     </FeaturedCard >
  //   ));
  // };

  // const activeInitiatives = () => {
  //   const activeCards = showAllActive?getActive:getActive?.slice(0,4);
  //   return activeCards?.map((details, index) => (
  //     <>
  //       <HdmTopCard key={index} background={details.color} onMouseEnter={() => setHover(details?.id)} onMouseLeave={() => setHover(-1)}>
  //         <div className="div-wrap">
  //           <div className="image">
  //             <img src={ImageUrl +"/"+ details?.initiative_white_icon} />
  //           </div>
  //           <div className="title">{details.initiative_name}</div>
  //           <div className="value">{commaSeperator(details?.total_participation)}</div>
  //           <div className="percent-user">{details?.user_initiative_taken_percentage}% of users have completed the initiative</div>
  //         </div>
  //         {onHover===details?.id&&<HoverBackground>
  //           <div className='view-button'
  //             onClick={() => showInitiativeInfo(details)}
  //             onMouseEnter={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}
  //             onMouseLeave={(e) => { e.target.style.background = '#F37A65'; e.target.style.color = '#FEFEFE'; }}>
  //             <div style={{ marginRight: '10px' }}>{RecognitionEyeIcon('#FEFEFE')}</div>{("View")}
  //           </div>
  //         </HoverBackground>}
  //       </HdmTopCard>
  //     </>
  //   ));
  // };

  // const upcomingInitiatives = () => {
  //   const upcomingCards = showAllUpcoming?getUpcoming:getUpcoming?.slice(0,4);
  //   return upcomingCards?.map((details, index) => (
  //     <>
  //       <HdmTopCard key={index} background={details?.color} isCardHeight={"196px"}>
  //         <div className="div-wrap">
  //           <div className="image">
  //             <img src={ImageUrl +"/"+ details?.initiative_white_icon} />
  //           </div>
  //           <div className="title">{details.initiative_name}</div>
  //           <div className="percent-user" style={{marginTop:"4px"}}>{Math.ceil((Number(new Date(details?.start_date) - new Date())/ (1000 * 60 * 60 * 24)))} days to go</div>
  //           <div className="deleteButton"><span className="icon" onClick={()=>showDeleteInitiativePopup(details)}>{DeleteIconBranding()}</span></div>
  //         </div>
  //       </HdmTopCard>
  //     </>
  //   ));
  // };

  const toggleShowEliteRecognition = () => {
    setShowEmployeeQuarter(!showEmployeeQuarter);
  };

  const toggleShowTopRecognition = () => {
    setShowEmployeeMonth(!showEmployeeMonth)
  };

  const onScrollMonth = (e) => {
    const diff = Math.round(e.target.scrollHeight - e.target.scrollTop) - Math.round(e.target.clientHeight);
    const isBottom = diff === 0 || diff === 1;
    if (isBottom && monthlyPerformers.length < monthlyMeta.total) {
      fetchMonthlyPerformers(monthlyPage + 1);
    }
  };

  const fetchQuarterlyPerformers = async (page) => {
    try {
      const res = await fetchApi(
        `${GetBestHealthPerformersV2}?company_id=${companyId}&reward_period_id=${selectedRewardPeriod.reward_period_id}&type=quarter&page=${page}&limit=7`,
        'GET'
      );
      if (res.status === 'success') {
        const users = res.data?.current_quarter?.data || res.data?.users || res.data || [];
        const total = res.data?.current_quarter?.total ?? res.total ?? 0;
        const quarter_name = res.data?.current_quarter?.quarter_name || '';
        setQuarterlyPerformers((prev) => page === 1 ? users : [...prev, ...users]);
        setQuarterlyMeta({ total, quarter_name });
        setQuarterlyPage(page);
      }
    } catch { /* silent */ }
  };

  const onScrollQuarter = (e) => {
    const diff = Math.round(e.target.scrollHeight - e.target.scrollTop) - Math.round(e.target.clientHeight);
    const isBottom = diff === 0 || diff === 1;
    if (isBottom && quarterlyPerformers.length < quarterlyMeta.total) {
      fetchQuarterlyPerformers(quarterlyPage + 1);
    }
  };

  const bestPerformer = (value)=>{
    const displayedEmployeeMonthly = showEmployeeMonth ? monthlyPerformers : monthlyPerformers?.slice(0, 5);
    const displayedEmployeeQuarterly = showEmployeeQuarter ? quarterlyPerformers : quarterlyPerformers?.slice(0, 5);
    return(
      <>
        <div className='top-performing' style={{display:"block"}} >
          <Table padding="8px 0" insight>
            <div className="heading">{monthlyMeta.month_name} | Monthly</div>
            {value !== "celebration" && (
              <div className="type">
                <div className="name">Employees</div>
                <div className="value">Total Initiatives</div>
              </div>
            )}
            <ScrollableContainer
              height={showEmployeeMonth ? "380px" : "330px"}
              showAllRows={showEmployeeMonth}
              onScroll={(e)=>onScrollMonth(e)}
            >
              {displayedEmployeeMonthly?.length>0?   displayedEmployeeMonthly?.map((data, index) => (
                <div className="item" key={index}>
                  {data.profile_image !== "profile-Image/default.png" ?<div className="profile">
                    <img src={ImageUrl + "/" + data?.profile_image} alt={data?.user_name} />
                  </div>:
                    <NameInitials id="name-initials" margin="0 8px 0 0">
                      {getInitials(data?.user_name)}
                    </NameInitials> 
                  }
                  <div className="name">{data?.user_name}</div>
                  <div className="value">{data?.participation_count}</div>
                </div>
              )):<div className="no-data">No Data Found</div>}
            </ScrollableContainer>
            {monthlyMeta.total > 5 && !showEmployeeMonth && (
              <div className="showmore">
                <div className="button" onClick={toggleShowTopRecognition}>
                  Show More
                </div>
              </div>
            )}
          </Table>

        </div>
        <div className='low-performing' style={{display:"block"}}>
          <Table padding="8px 0" insight>
            <div className="heading">{quarterlyMeta.quarter_name} | Quarterly</div>
            {value !== "celebration" && (
              <div className="type">
                <div className="name">Employees</div>
                <div className="value">Total Initiatives</div>
              </div>
            )}
            <ScrollableContainer
              height={showEmployeeQuarter ? "380px" : "330px"}
              showAllRows={showEmployeeQuarter}
              onScroll={(e)=>onScrollQuarter(e)}
            >
              {displayedEmployeeQuarterly?.length>0? displayedEmployeeQuarterly?.map((data, index) => (
                <div className="item" key={index}>
                  {data.profile_image !== "profile-Image/default.png" ?<div className="profile">
                    <img src={ImageUrl + "/" + data?.profile_image} alt={data?.user_name} />
                  </div>:
                    <NameInitials id="name-initials" margin="0 8px 0 0">
                      {getInitials(data?.user_name)}
                    </NameInitials> 
                  }
                  <div className="name">{data?.user_name}</div>
                  <div className="value">{data?.participation_count}</div>
                </div>
              )):<div className="no-data">No Data Found</div>}
            </ScrollableContainer>
            {quarterlyMeta.total > 5 && !showEmployeeQuarter && (
              <div className="showmore">
                <div className="button" onClick={toggleShowEliteRecognition}>
                  Show More
                </div>
              </div>
            )}
          </Table>
        </div>
      </>
    )
  }

  const openPopup = () => {
    setWellnessPriorityPopup(true);

  }

  const RecurringCard = () => (
    <InitiativeSlider
      title="Recurring"
      data={recurringInititives?.initiatives}
      showArrows={true}
      showDots={true}
      myFocusCard={true}
      loading={recurringLoading}
      icon={<null/>}
      companyId={companyId}
    />
  );

  const handleDeleteInititative = (id) => {
    setShowArchiveModal(true);
    setInitiativeToArchive(id);
  }



  const onLeaveMouse = () => {
    setScheduleHover(-1)
  }


  const onEnterMouse = (id) => {
    setScheduleHover(id)
  }


  const getDaysLeft = (startDate) => {

    const today = new Date();
  
    const start = new Date(startDate);
  
    const diffTime = start - today;
  
    const diffDays = Math.ceil(
      diffTime / (1000 * 60 * 60 * 24)
    );
  
    return diffDays > 0 ? diffDays : 0;
  };


  const ScheduledCard = () => {
    window.console.log("")
    return (
      <NewScheduledCard grid={4} margin={"25px"}>
        {upcomingInitiativesNew?.map((item) => (
          <EventCard
            isMarginBottom={"0px"}
            key={item.company_initiative_id}
            videoCSS={4}
            onMouseEnter={() =>
              onEnterMouse(item.company_initiative_id)
            }
            onMouseLeave={() => onLeaveMouse()}
            style={{border:"0.75px solid #DCDCDC"}}
          >
            <NewVideoPlayer>
              <Thumbnail
                src={`${ImageUrl}/${item.company_initiative_thumbnail}`}
                alt={item.initiative_name}
              />
            </NewVideoPlayer>
            {/* EDIT HOVER */}
            {scheduleHover === item.company_initiative_id && (
              <div className="hoverOverLayForTwoOptions">
            
                <div
                  className="getStarted"
                  onClick={() =>history.push({pathname: '/company/edit-initiative',state: { initiativeData: item }})}
                >
                  {/* {ViewEventIcon()} */}
                  {"Edit Initiative"}
                </div>
            
                <div
                  className="getStarted deleteButton"
                  onClick = {()=>handleDeleteInititative(item?.company_initiative_id)}
                  // onClick={() => deleteInitiative(item)}
                >
                  {/* {ViewEventIcon()} */}
                  {"Delete Initiative"}
                </div>
            
              </div>
            )}
            <NewContentV2 newPadding={"newPadding"} style={{borderTop:"none" , borderRadius:"0 0 12px 12px"}}>
              <div className="firstContainer">
                <div className="name">
                  {item?.initiative_name}
                </div>

                <div className="startDate">
                Start date - {moment(item?.start_date).format("MMM DD, YYYY")}
                </div>
              </div>
              <CircleContainerV2 marginRight={1} style={{marginTop:"32px"}}>
                <div className="daysText">
                  {getDaysLeft(item?.start_date)} days to go
                </div>
              </CircleContainerV2>
            </NewContentV2>
          </EventCard>
        ))}
      </NewScheduledCard>
    );
  };


    

  if (pageLoading) return <Waiting />;

  return (
    <>
      <MainContainer margin>
        {/* {renderHealthMetricCards()} */}
        <TopChallengesWrapper margin="0 0 0px 0">
          {showRecognitionDetails()}
        </TopChallengesWrapper>
        {wellnessPriorityInitiatives?.length > 0 ? (
          <>
            <Heading>
              Your Wellness Priorities
            </Heading>
            <TopChallengesWrapper margin="20px 0 0px 0" justify={'start'}>
              {wellnessPriorityInitiatives.map((details, index) => (
                <ActiveInitiativeCard
                  key={index}
                  details={details}
                  onBellClick={(d) => setNotificationInitiative(d)}
                  onLaunchClick={(d) => redirectToCompanyInitiative(d)}
                  onCardClick={(d) => history.push(`/company/initiative-details/${d?.company_initiative_id || d?.id}`)}
                />
              ))}
            </TopChallengesWrapper>
          </>) : (
          <NoInitiativeCard>
            <div className="image">
              <img src={ImageUrl+"/images/AdminReports/demo.svg"}/>
            </div>
            <div className="details">
              <div className="title">Your Wellness Priorities</div>
              <div className="subtext">Choose and organize the wellness areas that matter most to you. Customize your dashboard to reflect your goals and focus on the health insights that support your personal journey.</div>
            </div>
            <div className="buttonContent">
              <CommonButton width={"307px"} backgroundColor={"#DA6C74"} color={"#FEFEFE"} onClick={openPopup}>Let’s Get Started</CommonButton>
            </div>
          </NoInitiativeCard>
        )}

        {recurringInititives?.initiatives?.length ? RecurringCard()  : null}


        {healthSnapshot?.monthly_breakdown&&<div style={{marginTop:"20px",borderRadius: '12px',border:'0.75px solid #DCDCDC'}}><MonthlyBarChart heading="Monthly Breakdown" totalText="Initiative Participation" dataGraph={healthSnapshot?.monthly_breakdown} totalPercentage={healthSnapshot?.top_4_cards?.user_initiative_taken_percentage} total={healthSnapshot?.Initiative_participation} barColor={"#CE98B3"} barColorActive={"#A65C7C"} isDynamicMonth={true}  dynamicMonthsName={Object.keys(healthSnapshot?.monthly_breakdown)}/></div>}

        {/* {getFeatured?.length>0?null:showHideCustomize&&<NoInitiativeCard>
          <div className="image">
            <img src={ImageUrl+"/images/AdminReports/demo.svg"}/>
          </div>
          <div className="details">
            <div className="title">Customize your dashboard.</div>
            <div className="subtext">Set up your preferences to ensure your dashboard is tailored to meet your specific health data management needs,<br/> providing you with a seamless and personalized experience.</div>
            <div className="button">
              <CommonButton onClick={()=>history.push('/company/health/customize')}>Let’s Get Started</CommonButton>
            </div>
          </div>
        </NoInitiativeCard>} */}

        {upcomingInitiativesNew?.length > 0 &&
        <>
          <TextContainer isMargin={"20px 0"} isFontSize={"18px"} isLineHeight={"24px"} isFontWeight={"700"}>Scheduled</TextContainer>
          {ScheduledCard()}
        </>}

       
     

       


        
        {/* {getFeatured?.length>0&&<>
          <Heading>
            <div className='icon'>
              <img src={ImageUrl + "/admin-recognition/top-performer.svg"} />
            </div>
            Featured Initiatives
          </Heading>
          <TopChallengesWrapper margin="20px 0 0px 0" justify gap="20px 32px">
            {featuerdInitiatives()}
          </TopChallengesWrapper>
        </>} */}

        {activeInitiativesNew?.length > 0 && (
          <>
            <Heading>
              {/* <div className='icon'><WellnessInitiatives /></div> */}
              Active Initiatives
            </Heading>
            <TopChallengesWrapper margin="20px 0 0px 0" justify={'start'}>
              {activeInitiativesNew.map((details, index) => (
                <ActiveInitiativeCard
                  key={index}
                  details={details}
                  onBellClick={(d) => setNotificationInitiative(d)}
                  onCardClick={(d) => history.push(`/company/initiative-details/${d?.company_initiative_id || d?.id}`)}
                />
              ))}
            </TopChallengesWrapper>
          </>
        )}
        {/* {getActive?.length>0&&hideCardsForPreviousYear&&<>
          <Heading>
            <div className='icon'>
              <WellnessInitiatives/>
            </div>
            Active Initiatives
            {getActive.length>4&&!showAllActive&&<div className="dropdown">
              <ShowMore onClick={()=>setShowAllActive(true)} >
                <div className="show-more">Show more</div> <div className="icon"><DownArrow/></div>
              </ShowMore >
            </div>}
          </Heading>
          <TopChallengesWrapper margin="20px 0 0px 0" justify gap="20px 32px" >
            {activeInitiatives()}
            {getActive?.length<4 && showHideCustomize&&<div className="button">
              <CommonButton id="hdm-launch-initiative" width="200px" padding="10px 16px" onClick={()=>manageHealthTabs('library')}><div className="icon"><LaunchInitiatives/></div>Launch Initiative</CommonButton>
            </div>}
          </TopChallengesWrapper>
        </>} */}
        {/* {getUpcoming?.length>0&&hideCardsForPreviousYear&&<>
          <Heading>
            <div className='icon'>
              <UpcomingInitiatives/>
            </div>
            Upcoming Initiatives
            {getUpcoming.length>4&&!showAllUpcoming&&<div className="dropdown">
              <ShowMore onClick={()=>setShowAllUpcoming(true)} >
                <div className="show-more">Show more</div> <div className="icon"><DownArrow/></div>
              </ShowMore >
            </div>}
          </Heading>
          <TopChallengesWrapper margin="20px 0 0px 0" justify gap="20px 32px" >
            {upcomingInitiatives()}
          </TopChallengesWrapper>
        </>} */}
        <Heading>
          <div className='icon'>
            {/* <img src={ImageUrl + "/admin-recognition/top-performer.svg"} /> */}
            {StarIcon()}
          </div>
          Best Performers
        </Heading>
        <div className="main-top-low-card" style={{marginTop:"20px"}}>
          {bestPerformer()}
        </div>
        <div className="main-top-low-card" style={{marginTop:"20px"}}>
          {deptAndLocData?.total_top_departments>0&&<div className='top-performing'>{topDepartment()}</div>}
          {deptAndLocData?.total_top_locations>0&&<div className='top-performing'>{topLocation()}</div>}
        </div>

        {showDetailPopup && <DetailPopup showModal={showDetailPopup} detailInitiative={detailInitiative} onClose={hideInitiativeInfo} companyId={companyId}/>}
        {deleteInitiative&&<DeletePopup
          showModal={deleteInitiative}
          onClose={hideDeleteInitiative}
          deleteConsumer={deleteInitiativeApiCall}
          type="initiative"
        />}
        {notificationInitiative && (
          <CustomNotification
            showModal={!!notificationInitiative}
            onClose={() => setNotificationInitiative(null)}
            type="initiative"
            companyInitiativeId={notificationInitiative?.company_initiative_id || notificationInitiative?.id}
            companyId={companyId}
          />
        )}
        
        
        {wellnessPriorityPopup &&<WellnessPrioritiesPopup companyId={companyId}  showPopup={wellnessPriorityPopup} closePopup={()=>setWellnessPriorityPopup(false)}/>}
     
        {showArchiveModal && (
          <CommonModalNew
            show={showArchiveModal}
            modalWidth={"400px"}
            title="Delete Initiative"
            confirmButtonWidth={"180px"}
            description="Are you sure you want to delete this initiative?"
            subDescription="This action cannot be undone, and all associated data will be permanently removed from the system."
            onCancel={() => setShowArchiveModal(false)}
            onConfirm={handleArchive}
            cancelText="Keep Initiative"
            confirmButtonText="Delete Initiative"
            icon={<WarningIconV1/>}
            buttonIcon={<></>}
            cancelButtonWidth={"150px"}
            descriptionColor={'#CE7841'}
          />
        )}
     
     
      </MainContainer>
    </>
  );
};

CompanyAnalytics.propTypes = {
  selectedYearInfo: PropTypes.number,
  companyId: PropTypes.number,
  history: PropTypes.object,
  manageHealthTabs: PropTypes.func,
  showHideCustomize: PropTypes.bool,
  getUpcoming: PropTypes.array,
  getActive: PropTypes.array,
  getFeatured: PropTypes.array,
  selectedYear: PropTypes.number,
  fetchUpcomingInitiatives: PropTypes.func,
  selectedRewardPeriod: PropTypes.object
};

const mapStateToProps = (state) => ({
  selectedYearInfo: state.companyDashboard.selectedYearInfo
});

export default connect(mapStateToProps, null)(CompanyAnalytics);
